import { Dropdown, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { ProfileImage } from '../../components';
import ProfileDropDown from './dropdown';
import { IoIosArrowDown } from "react-icons/io";
import './topHeader.css'

const getStoredAuthUser = () => {
    try {
        return JSON.parse(localStorage.getItem("authUser"));
    } catch {
        return null;
    }
};

const resolveProfileUser = (authState) => {
    const storedAuth = getStoredAuthUser();
    const payload = authState?.user;
    const nestedUser = payload?.user;
    const flatUser = payload?.fullName || payload?.imageUrl || payload?.imageThumbUrl ? payload : null;

    return nestedUser || flatUser || storedAuth?.user || null;
};

const getProfileImage = (user) => {
    return user?.imageThumbUrl || user?.imageUrl;
};

const TopHeader = ({ isTablet }) => {

    const authUser = useSelector((state) => state.auth);

    const [isAdmin, setIsAdmin] = useState('');

    const [adminProfile, setAdminProfile] = useState({
        name: '',
        image: ''
    })

    useEffect(() => {
        const user = resolveProfileUser(authUser);

        setIsAdmin(user?.roleName || '');
        setAdminProfile({
            name: user?.fullName || '',
            image: getProfileImage(user)
        });
    }, [authUser])


    const showName = (name) => {
        return name?.length > 10 ? `${name.slice(0, 10)}...` : name;
    };

    return (
        <Row className='top-header-main-container' justify='end' align='middle'>
            {isTablet ? <span>{`Welcome Back, ${isAdmin ? isAdmin : 'Admin'}!`}</span> : ''}
            <Dropdown
                overlay={<ProfileDropDown />}
            >
                <a
                    className="ant-dropdown-link dropdown-item"
                    onClick={(e) => e.preventDefault()}
                >
                    <ProfileImage
                        asAvatar
                        src={adminProfile?.image}
                        size={40}
                        className="admin-profile-avatar"
                    />
                    <span className="mx-10">
                        {showName(adminProfile?.name)}
                    </span>
                    <IoIosArrowDown />
                </a>
            </Dropdown>
        </Row>
    )
}

export default TopHeader